// extracted by mini-css-extract-plugin
export var container = "_5s-0";
export var fallback = "_5s-5";
export var fallbackIcon = "_5s-6";
export var hidden = "_5s-2";
export var image = "_5s-3";
export var loaded = "_5s-4";
export var placeholder = "_5s-1";